/* eslint-disable no-unused-vars */
const THREE = window.THREE;
import HttpService from '@/utils/httpService';
import store from '..';
import notStartedIcon from '@/images/clock 1.png';
import inProgressIcon from '@/images/work-in-progress 1.png';
import completedIcon from '@/images/check 1.png';
import canceledIcon from '@/images/Canceled.png';
import suspendIcon from '@/images/Suspended.png';
import overdueIcon from '@/images/overdue.png';
import dueIcon from '@/images/due.png';
import { clearThemingColors, setPermeativeElementsTheme } from '@/utils/forgeUtils';

export const WorkPackProgressDashboard = {
    state: {
        showWorkPackProgressDashboard: false,

        dispatchResetWpDashboardGrid: false,

        // Project List
        wpProjectListIsLoading: false,
        wpProjectList: [],

        // Work pack status
        wpStatusIsLoading: false,
        wpStatusLastRequest: null,
        WPStatus: [
            {
                name: 'Not Started',
                colorClass: 'not-started-color',
                icon: notStartedIcon,
                value: 0,
                isSelected: false
            },
            {
                name: 'In Progress',
                colorClass: 'inprogress-color',
                icon: inProgressIcon,
                value: 0,
                isSelected: false
            },
            {
                name: 'Overdue',
                colorClass: 'canceled-color',
                icon: canceledIcon,
                value: 0,
                isSelected: false
            },
            {
                name: 'Completed',
                colorClass: 'completed-color',
                icon: completedIcon,
                value: 0,
                isSelected: false
            },
        ],

        // Job Card status
        jobCardStatusIsLoading: false,
        jobCardStatusLastRequest: null,
        JobCardStatus: [
            {
                name: 'Not Started',
                colorClass: 'not-started-color',
                icon: notStartedIcon,
                value: 0,
                isSelected: false
            },
            {
                name: 'In Progress',
                colorClass: 'inprogress-color',
                icon: inProgressIcon,
                value: 0,
                isSelected: false
            },
            {
                name: 'Overdue',
                colorClass: 'canceled-color',
                icon: canceledIcon,
                value: 0,
                isSelected: false
            },
            {
                name: 'Completed',
                colorClass: 'completed-color',
                icon: completedIcon,
                value: 0,
                isSelected: false
            },
        ],

        // Job tag status
        WPDashboardTagChartIsLoading: false,
        WPDashboardTagChartLastRequest: null,
        WPDashboardTagChart: [
            {
                label: 'Completed',
                color: '#7FC67A',
                value: 0,
                isSelected: true
            },
            {
                label: 'In Progress',
                color: '#FF7B00',
                value: 0,
                isSelected: true
            },
            {
                label: 'Not Started',
                color: '#7E7E7F',
                value: 0,
                isSelected: true
            },
            {
                label: 'Overdue',
                color: '#D60000',
                value: 0,
                isSelected: true
            },
        ],

        // Data grid
        wpGridDataIsLoading: false,
        wpGridDataLastRequest: null,
        wpGridData: [],

        // Schedule chart
        wpScheduleChartIsLoading: false,
        wpScheduleChartLastRequest: null,
        wpScheduleChart: [],
    },
    getters: {
        GET_SHOW_WORK_PACK_PROGRESS_DASHBOARD: state => {
            return state.showWorkPackProgressDashboard;
        },
        GET_DISPATCH_RESET_WP_DASHBOARD_GRID: state => {
            return state.dispatchResetWpDashboardGrid;
        },
        GET_WP_PROJECT_LIST_IS_LOADING: state => {
            return state.wpProjectListIsLoading;
        },
        GET_WP_PROJECT_LIST: state => {
            return state.wpProjectList;
        },
        GET_WP_SELECTED_PROJECTS: (state) => {
            return state.wpProjectList.filter(p => p.isChecked).filter(p => p.name !== 'Select All').map((p) => p.name);
        },
        GET_WP_STATUS_IS_LOADING: state => {
            return state.wpStatusIsLoading;
        },
        GET_WP_STATUS_LAST_REQUEST: state => {
            return state.wpStatusLastRequest;
        },
        GET_WP_STATUS: state => {
            return state.WPStatus;
        },
        GET_WP_SELECTED_STATUS: (state) => {
            return state.WPStatus.filter(s => s.isSelected).map((s) => s.name);
        },
        GET_JOB_CARD_STATUS_IS_LOADING: state => {
            return state.jobCardStatusIsLoading;
        },
        GET_JOB_CARD_STATUS_LAST_REQUEST: state => {
            return state.jobCardStatusLastRequest;
        },
        GET_JOB_CARD_STATUS: state => {
            return state.JobCardStatus;
        },
        GET_JOB_CARD_SELECTED_STATUS: (state) => {
            return state.JobCardStatus.filter(s => s.isSelected).map((s) => s.name);
        },
        GET_WP_TAG_CHART_IS_LOADING: state => {
            return state.WPDashboardTagChartIsLoading;
        },
        GET_WP_TAG_CHART_LAST_REQUEST: state => {
            return state.WPDashboardTagChartLastRequest;
        },
        GET_WP_TAG_CHART: state => {
            return state.WPDashboardTagChart;
        },
        GET_WP_TAG_CHART_SELECTED_STATUS: (state) => {
            return state.WPDashboardTagChart.filter(s => s.isSelected).map((s) => s.label);
        },
        GET_WP_GRID_DATA_IS_LOADING: state => {
            return state.wpGridDataIsLoading;
        },
        GET_WP_GRID_DATA_LAST_REQUEST: state => {
            return state.wpGridDataLastRequest;
        },
        GET_WP_GRID_DATA: state => {
            return state.wpGridData;
        },
        GET_WP_SCHEDULE_CHART_IS_LOADING: state => {
            return state.wpScheduleChartIsLoading;
        },
        GET_WP_SCHEDULE_CHART_LAST_REQUEST: state => {
            return state.wpScheduleChartLastRequest;
        },
        GET_WP_SCHEDULE_CHART: state => {
            return state.wpScheduleChart;
        },
    },
    mutations: {
        SET_SHOW_WORK_PACK_PROGRESS_DASHBOARD: (state, payload) => {
            state.showWorkPackProgressDashboard = payload;
        },
        SET_DISPATCH_RESET_WP_DASHBOARD_GRID: (state, payload) => {
            state.dispatchResetWpDashboardGrid = payload;
        },
        SET_WP_PROJECT_LIST_IS_LOADING: (state, payload) => {
            state.wpProjectListIsLoading = payload;
        },
        SET_WP_PROJECT_LIST: (state, payload) => {
            state.wpProjectList = payload;
        },
        SET_WP_STATUS_LAST_REQUEST: (state, payload) => {
            state.wpStatusLastRequest = payload;
        },
        SET_WP_STATUS_IS_LOADING: (state, payload) => {
            state.wpStatusIsLoading = payload;
        },
        SET_WP_STATUS: (state, payload) => {
            state.WPStatus = payload;
        },
        SET_JOB_CARD_STATUS_IS_LOADING: (state, payload) => {
            state.jobCardStatusIsLoading = payload;
        },
        SET_JOB_CARD_LAST_REQUEST: (state, payload) => {
            state.jobCardStatusLastRequest = payload;
        },
        SET_JOB_CARD_STATUS: (state, payload) => {
            state.JobCardStatus = payload;
        },
        SET_WP_TAG_CHART_IS_LOADING: (state, payload) => {
            state.WPDashboardTagChartIsLoading = payload;
        },
        SET_WP_TAG_CHART_LAST_REQUEST: (state, payload) => {
            state.WPDashboardTagChartLastRequest = payload;
        },
        SET_WP_TAG_CHART: (state, payload) => {
            state.WPDashboardTagChart = payload;
        },
        SET_WP_GRID_DATA_IS_LOADING: (state, payload) => {
            state.wpGridDataIsLoading = payload;
        },
        SET_WP_GRID_DATA_LAST_REQUEST: (state, payload) => {
            state.wpGridDataLastRequest = payload;
        },
        SET_WP_GRID_DATA: (state, payload) => {
            state.wpGridData = payload;
        },
        SET_WP_SCHEDULE_CHART_IS_LOADING: (state, payload) => {
            state.wpScheduleChartIsLoading = payload;
        },
        SET_WP_SCHEDULE_CHART_LAST_REQUEST: (state, payload) => {
            state.wpScheduleChartLastRequest = payload;
        },
        SET_WP_SCHEDULE_CHART: (state, payload) => {
            state.wpScheduleChart = payload;
        },
    },
    actions: {
        GetWpProjectList({ commit }) {

            const unique = new Date().getTime();

            commit('SET_WP_PROJECT_LIST_IS_LOADING', true);

            commit('SET_WP_PROJECT_LIST', []);

            let client = store.state.clientName;
            let contract = store.state.contractName;
            let asset = store.state.assetName;

            HttpService.get(`api/WPDashboard/projects?clientName=${client}&contractName=${contract}&assetName=${asset}`)
            .then(({ data }) => {

                if (data.length === 0) {
                    commit('SET_WP_PROJECT_LIST_IS_LOADING', false);
                    return;
                }

                let projectList = data.map((p) => {
                    return {
                        name: p,
                        isChecked: false
                    }
                });

                projectList.unshift({
                    name: 'Select All',
                    isChecked: false
                });

                commit('SET_WP_PROJECT_LIST', projectList);
                
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                commit('SET_WP_PROJECT_LIST_IS_LOADING', false);
            });
        },
        GetWpStatus({ commit }) {

            if (!store.state.clientName || !store.state.assetName) return;

            if (!store.getters.GET_WP_SELECTED_PROJECTS?.length) {

                let status = store.getters.GET_WP_STATUS;

                status.forEach(s => {
                    s.value = 0;
                });

                commit('SET_WP_STATUS', status);

                return;
            }

            let unique = new Date().getTime();

            commit('SET_WP_STATUS_IS_LOADING', true);

            commit('SET_WP_STATUS_LAST_REQUEST', unique);

            let tagStatus = store.getters.GET_WP_TAG_CHART_SELECTED_STATUS;

            //# Ignore the filter if all options was selected.
            if (tagStatus?.length === 4) tagStatus = []; 

            HttpService.post({
                url: 'api/WPDashboard/wpStatus',
                data: {
                    client: store.state.clientName,
                    asset: store.state.assetName,
                    projects: store.getters.GET_WP_SELECTED_PROJECTS ?? [],
                    workPackStatus: [],
                    jobCardStatus: store.getters.GET_JOB_CARD_SELECTED_STATUS ?? [],
                    tagStatus: tagStatus ?? [],
                }
            }).then(({ data }) => {

                if (unique !== store.getters.GET_WP_STATUS_LAST_REQUEST) return;
                    
                let status = store.getters.GET_WP_STATUS;

                status.forEach(s => {

                    let result = data.find(d => d.status === s.name);

                    s.value = result?.count ?? 0;
                });

                commit('SET_WP_STATUS', status);
            }).catch(error => {
                console.log(error);
            }).finally(() => {
                commit('SET_WP_STATUS_IS_LOADING', false);
            });
            
        },
        GetJobCardStatus({ commit }) {

            if (!store.state.clientName || !store.state.assetName) return;

            if (!store.getters.GET_WP_SELECTED_PROJECTS?.length) {

                let status = store.getters.GET_JOB_CARD_STATUS;

                status.forEach(s => {
                    s.value = 0;
                });

                commit('SET_JOB_CARD_STATUS', status);

                return;
            }

            let unique = new Date().getTime();

            commit('SET_JOB_CARD_STATUS_IS_LOADING', true);

            commit('SET_JOB_CARD_LAST_REQUEST', unique);

            let tagStatus = store.getters.GET_WP_TAG_CHART_SELECTED_STATUS;

            //# Ignore the filter if all options was selected.
            if (tagStatus?.length === 4) tagStatus = []; 

            HttpService.post({
                url: 'api/WPDashboard/jobCardStatus',
                data: {
                    client: store.state.clientName,
                    asset: store.state.assetName,
                    projects: store.getters.GET_WP_SELECTED_PROJECTS ?? [],
                    workPackStatus: store.getters.GET_WP_SELECTED_STATUS ?? [],
                    jobCardStatus: [],
                    tagStatus: tagStatus ?? [],
                }
            }).then(({ data }) => {

                if (unique !== store.getters.GET_JOB_CARD_STATUS_LAST_REQUEST) return;
                    
                let status = store.getters.GET_JOB_CARD_STATUS;

                status.forEach(s => {

                    let result = data.find(d => d.status === s.name);

                    s.value = result?.count ?? 0;
                });

                commit('SET_JOB_CARD_STATUS', status);

            }).catch(error => {

                console.log(error);

            }).finally(() => {

                commit('SET_JOB_CARD_STATUS_IS_LOADING', false);

            });
        },
        GetTagStatus({ commit }) {
            
            if (!store.state.clientName || !store.state.assetName) return;

            if (!store.getters.GET_WP_SELECTED_PROJECTS?.length) {
                
                let status = store.getters.GET_WP_TAG_CHART;

                status.forEach(s => {
                    s.value = 0;
                });

                commit('SET_WP_TAG_CHART', status);

                return;
            }

            let unique = new Date().getTime();

            commit('SET_WP_TAG_CHART_IS_LOADING', true);

            commit('SET_WP_TAG_CHART_LAST_REQUEST', unique);

            HttpService.post({
                url: 'api/WPDashboard/tagStatus',
                data: {
                    client: store.state.clientName,
                    asset: store.state.assetName,
                    projects: store.getters.GET_WP_SELECTED_PROJECTS ?? [],
                    workPackStatus: store.getters.GET_WP_SELECTED_STATUS ?? [],
                    jobCardStatus: store.getters.GET_JOB_CARD_SELECTED_STATUS ?? [],
                    tagStatus: [],
                }
            }).then(({ data }) => {

                if (unique !== store.getters.GET_WP_TAG_CHART_LAST_REQUEST) return;
                    
                let status = store.getters.GET_WP_TAG_CHART;

                status.forEach(s => {

                    let result = data.find(d => d.status === s.label);

                    s.value = result?.count ?? 0;
                });

                commit('SET_WP_TAG_CHART', status);

            }).catch(error => {

                console.log(error);

            }).finally(() => {

                commit('SET_WP_TAG_CHART_IS_LOADING', false);

            });
        },
        GetWpGridData({ commit }, payload) {

            return new Promise((resolve, reject) => {

                if (!store.state.clientName || !store.state.assetName) return;
    
                if (!store.getters.GET_WP_SELECTED_PROJECTS?.length) {
    
                    commit('SET_WP_GRID_DATA', []);
    
                    resolve([]);

                    return;
                }

                let unique = new Date().getTime();
    
                commit('SET_WP_GRID_DATA_IS_LOADING', true);
    
                commit('SET_WP_GRID_DATA_LAST_REQUEST', unique);

                HttpService.post({
                    url: 'api/WPDashboard/wpGridData',
                    data: {
                        startIndex: payload.startIndex ?? 0,
                        endIndex: payload.endIndex ?? 100,
                        colId: payload.colId ?? 'TagName',
                        sort: payload.sort ?? 'ASC',
                        filters: payload.filters ?? [],
                        client: store.state.clientName,
                        asset: store.state.assetName,
                        projects: store.getters.GET_WP_SELECTED_PROJECTS ?? [],
                        workPackStatus: store.getters.GET_WP_SELECTED_STATUS ?? [],
                        jobCardStatus: store.getters.GET_JOB_CARD_SELECTED_STATUS ?? [],
                        tagStatus: store.getters.GET_WP_TAG_CHART_SELECTED_STATUS ?? [],
                    }
                }).then(({ data }) => {
    
                    if (unique !== store.getters.GET_WP_GRID_DATA_LAST_REQUEST) return;
    
                    commit('SET_WP_GRID_DATA', data);
    
                    resolve(data);
    
                }).catch(error => {
    
                    console.log(error);
    
                    reject(error);
    
                }).finally(() => {
    
                    commit('SET_WP_GRID_DATA_IS_LOADING', false);
    
                });
            });
        },
        GetWpSchedule({ commit }) {
                
                if (!store.state.clientName || !store.state.assetName) return;

                if (!store.getters.GET_WP_SELECTED_PROJECTS?.length) {

                    commit('SET_WP_SCHEDULE_CHART', {
                        actualDates: [],
                        forecastDates: [],
                    });

                    return;
                }
    
                let unique = new Date().getTime();
    
                commit('SET_WP_SCHEDULE_CHART_IS_LOADING', true);
    
                commit('SET_WP_SCHEDULE_CHART_LAST_REQUEST', unique);

                //# Ignore the filter if all options was selected.
                let tagStatus = store.getters.GET_WP_TAG_CHART_SELECTED_STATUS;

                if (tagStatus?.length === 4) tagStatus = [];
    
                HttpService.post({
                    url: 'api/WPDashboard/wpSchedule',
                    data: {
                        client: store.state.clientName,
                        asset: store.state.assetName,
                        projects: store.getters.GET_WP_SELECTED_PROJECTS ?? [],
                        workPackStatus: store.getters.GET_WP_SELECTED_STATUS ?? [],
                        jobCardStatus: store.getters.GET_JOB_CARD_SELECTED_STATUS ?? [],
                        tagStatus: tagStatus ?? [],
                    }
                }).then(({ data }) => {
    
                    if (unique !== store.getters.GET_WP_SCHEDULE_CHART_LAST_REQUEST) return;

                    if (data.length === 0) {
                        commit('SET_WP_SCHEDULE_CHART', {
                            actualDates: [],
                            forecastDates: [],
                        });
                        
                        return;
                    }

                    let actualDates = [];
                    let forecastDates = [];
    
                    data.forEach((record) => {
                        actualDates.push({ x: record.workPackTitle, y: new Date(record.actualDate).getTime() });
                        forecastDates.push({ x: record.workPackTitle, y: new Date(record.forecastDate).getTime() });

                        commit('SET_WP_SCHEDULE_CHART', {
                            actualDates: actualDates,
                            forecastDates: forecastDates,
                        });
                    });
                    
    
                }).catch(error => {
    
                    console.log(error);
    
                }).finally(() => {
    
                    commit('SET_WP_SCHEDULE_CHART_IS_LOADING', false);
    
                });
        },
        UpdateModelWithIsolatedTags({ dispatch }, payload) {

            if (!store.state.viewer) return;

            if (!payload) return;

            if (!store.state.clientName || !store.state.assetName) return;

            if (!store.getters.GET_WP_SELECTED_PROJECTS?.length) return;

            HttpService.post({
                url: `api/WPDashboard/getIsolatedTags`,
                data: {
                    client: store.state.clientName,
                    asset: store.state.assetName,
                    assetId: store.state.assetId,
                    projects: store.getters.GET_WP_SELECTED_PROJECTS ?? [],
                    tagId: payload?.tagId ?? 0,
                    workPackId: payload?.workPackId ?? 0,
                    jobCardId: payload?.jobCardId ?? 0,
                }
            }).then(({ data }) => {

                dispatch('IsolateModelTags', data);

            }).catch(error => {

                console.log(error);
            })
        },
        updateModelWithIsolatedTagsByFilters({ dispatch }) {

            if (!store.state.viewer) return;

            if (!store.state.clientName || !store.state.assetName) return;

            if (!store.getters.GET_WP_SELECTED_PROJECTS?.length) return;
            
            let wpStatus = store.getters.GET_WP_SELECTED_STATUS ?? [];            
            let jobCardStatus = store.getters.GET_JOB_CARD_SELECTED_STATUS ?? [];
            let tagStatus = store.getters.GET_WP_TAG_CHART_SELECTED_STATUS ?? [];

            let wpStatusIsValid =  wpStatus?.length !== 0;
            let jobCardStatusIsValid = jobCardStatus?.length !== 0;
            let tagStatusIsValid = tagStatus?.length !== 4 && tagStatus?.length !== 0;

            if (!wpStatusIsValid && !jobCardStatusIsValid && !tagStatusIsValid) {
                dispatch('ClearIsolation');
                return;
            }

            HttpService.post({
                url: 'api/WPDashboard/getIsolatedTagsByFilters',
                data: {
                    client: store.state.clientName,
                    asset: store.state.assetName,
                    assetId: store.state.assetId,
                    projects: store.getters.GET_WP_SELECTED_PROJECTS ?? [],
                    workPackStatus: wpStatus,
                    jobCardStatus: jobCardStatus,
                    tagStatus: tagStatus,
                }
            }).then(({ data }) => {

                dispatch('IsolateModelTags', data);

            }).catch(error => {

                console.log(error);

            });
        },
        ClearIsolation({ commit }) {
            let themedDbIds = store.getters['GET_THEMED_DB_IDS'];

            if (themedDbIds?.length) {

                clearThemingColors(store.state.viewer);
    
                store.state.forgeService.getMainExtension().endIsolation();

                store.commit('setIsIsolating3D', false);
            }

        },
        IsolateModelTags({ commit, getters, dispatch }, tags) {

            if (!store.state.viewer?.model) {
                dispatch({ type: "alert_Forge", message: 'Please open the 3D model!' });
                return;
            }

            if (!tags?.length) {
                dispatch({ type: "alert_Forge", message: 'No Model Items Exist for tags!' });
                return;
            }

            dispatch('GET_BASE_TAGS_BY_IDS', tags.map((tag) => tag.id))
            .then(data => {
                if (!data || data.length == 0) {
                    dispatch({ type: "alert_Forge", message: 'No Model Items Exist for tags!' });
                    return;
                }

                let themedDbIds = store.getters['GET_THEMED_DB_IDS'];
                let needToReset = store.state.isGhostingOn && !store.state.isGhostingWireframe

                if (!!themedDbIds?.length && needToReset) clearThemingColors(store.state.viewer);

                store.state.isGhostingOn = true;

                let dbIdsIsolate = [];

                data.forEach(tag => {
                    let dbIds = tag.children.map(t => t.dbId) ?? [];
                    dbIdsIsolate.push(...dbIds);

                    //if you want to show workpack change to "status" here
                    let status = tags.find(l => l.id == tag.id)?.tagStatus;

                    if (!status) return;

                    let color = '#7E7E7F';

                    switch (status) {
                        case 'Completed':
                            color = '#7FC67A';
                            break;
                        case 'In Progress':
                            color = '#FF7B00';
                            break;
                        case 'Not Started':
                            color = '#7E7E7F';
                            break;
                        case 'Overdue':
                            color = '#D60000';
                            break;
                    }

                    if (!color) return;

                    color = new THREE.Color(color);

                    color = new THREE.Vector4(color.r, color.g, color.b, 1);

                    setPermeativeElementsTheme(dbIds, color);
                });

                store.commit('SET_THEMED_DB_IDS', dbIdsIsolate);

                store.state.forgeService.getMainExtension().isolateDbIds(dbIdsIsolate, store.state.viewer.model);

                store.state.forgeService.updateGhosting();
            })
            .catch(console.error);
        }
    }
}